// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3bXh-","colMin":"styles_colMin__2zEIW","colCheckbox":"styles_colCheckbox__1Mem2"};